<template>
  <div class="main-body">
    <div class="header">检测报告列表</div>
    <div class="out">
      <div class="search2">

          <div style="float:right">
            <el-input
              placeholder="请输老人名称"
              v-model="userName"
              clearable
              style="margin:0 10px;width:200px"
            ></el-input>
            <el-button size="mini"
              style="margin-left:10px;float:right"
              type="primary"
              icon="el-icon-search"
              @click="getList(true)"
            >搜索</el-button>
          </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column prop="userName" label="老人名称"></el-table-column>

        <el-table-column prop="hospitalName" label="医院名称"></el-table-column>

        <el-table-column prop="inspectTime" label="检查时间" :formatter="timefilter"></el-table-column>

        <el-table-column prop="createTime" label="上传时间" :formatter="timefilter"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="lookPicture(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
            background
            layout="prev, pager, next"
            :total="totalItems"
            :page-size="20"
            :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="lookPicture" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
  </div>
</template>

<script>
import { timeStr, timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import Add from "./LookPicture";

import { getStaffCode } from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {
      tableLoading: false,
      showModalAdd: false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,
      userName: "",
    };
  },
  components: {
    Add,
  },
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      console.log(val);
      this.th = val;
    },
  },
  methods: {
    lookPicture: function (row) {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.lookPicture.init(row);
    },

    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true
      this.$axios({
        method: "post",
        url: this.$shopUrl + "Report/GetPageByGovernment",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          userName: this.userName,
          pageSize: this.pageSize,
        },
      })
        .then((response) => {
          _this.tableLoading=false
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          _this.tableLoading=false
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
</style>
